export default {
    scheduler: {
        getSchedulers: {
            type: "get",
            error: {
                default: "Unable to load scheduler information.",
            },
        },
        getAppoints: {
            type: "get",
            error: {
                default: "Unable to load appointment information.",
            },
        },
        getPatientByClinician: {
            type: "get",
            error: {
                default: "Unable to load Patient By Clinician information.",
            },
        },
        getReferences: {
            type: "get",
            error: {
                default: "Unable to load References information.",
            },
        },
        editScheduler: {
            type: "patch",
            error: {
                default: "Failed to save scheduler.",
            },
        },
        editSchedulerStatus: {
            type: "patch",
            error: {
                default: "Failed to save scheduler status.",
            },
        },
        getScheduler: {
            type: "get",
            error: {
                default: "Unable to load scheduler.",
            },
        },
        deleteScheduler: {
            type: "put",
            error: {
                default: "Failed to delete scheduler.",
            },
        },
        newScheduler: {
            type: "Post",
            error: {
                default: "Failed to create scheduler.",
            },
        },
        getSchedulerAssess: {
            type: "get",
            error: {
                default: "Unable to load scheduler assess.",
            },
        },
    },

};
